import { render } from "./InsightsPage.vue?vue&type=template&id=f4a0fb78"
import script from "./InsightsPage.vue?vue&type=script&lang=js"
export * from "./InsightsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__